import React from 'react';
import SliderBannerGalery from '../../../../shared/components/atoms/slider-galery/slider-banner-galery';
import useMobile from '../../../hooks/useMobile';
import Breadcumb from '../../atoms/breadcrumb/breadcrumb';
import Button from '../../atoms/button/button';
import './banner.scss';

const handleProductFormRedirect = (customUrl, slug) => {
    if(customUrl){
        window.location.href = slug
    }else{
        window.location.href = siteUrl + '/' + slug
    }
}

const Banner = props => {

    const { 
        imagen, 
        imagenMobile, 
        titulo, 
        children, 
        showImagenMobile, 
        showBreadCrumb, 
        bannerSlider, 
        page = 'Home', 
        subBanner, 
        estiloTc, 
        productoEstiloTc
    } = props;
   
    const isMobile = useMobile();
    
    return (
        <div className="m-banner_flex-container">            
            <div className="m-banner_flex-item">
                <div className={"m-banner_breadcrumb-container " + ((!isMobile && showBreadCrumb) ? 'show' : '')}>
                    <Breadcumb page={ page }/>
                </div>
                {children}                
            </div>
            {
                (!productoEstiloTc || !isMobile) &&
                <div className="m-banner_flex-item">
                {
                    subBanner || ( !bannerSlider || bannerSlider?.length < 2 ) ? (
                        <div className={"m-banner_img-container " + (showImagenMobile && !estiloTc ? 'show' : '')}>
                            <img
                                src={(isMobile && imagenMobile) ? imagenMobile : imagen}
                                alt={titulo}
                                title={titulo}
                            />                   
                        </div>
                    ) : (
                        <SliderBannerGalery banner={bannerSlider} /> 
                    )                    
                }    
                                      
                {/*<div className={"m-banner_img-container " + (showImagenMobile ? 'show' : '')}>
                    <img
                        src={(isMobile && imagenMobile) ? imagenMobile : imagen}
                        alt={titulo}
                        title={titulo}
                    />                   
    </div>*/}
            </div>
            }            
        </div>
    )
}

export default Banner
